import React, { useState } from 'react';
import Footer from '../layout/Footer';
import Navbar from '../layout/Navbar';
import { Eye, Printer } from 'lucide-react';
import { ChevronLeft, ChevronRight, FastForward, Rewind } from 'lucide-react';

export default function Prescriptions() {
  const prescriptions = [
    { date: '9 Jan 2024', visitType: 'Outpatient', doctorName: 'Sandeep Singh', specialty: 'Cardiology' },
    { date: '12 Dec 2023', visitType: 'Outpatient', doctorName: 'Sandeep Singh', specialty: 'Cardiology' },
    { date: '2 Dec 2023', visitType: 'Inpatient', doctorName: 'Sandeep Singh', specialty: 'Cardiology' },
    { date: '1 Dec 2023', visitType: 'Inpatient', doctorName: 'Sandeep Singh', specialty: 'Cardiology' },
    { date: '1 Dec 2023', visitType: 'Inpatient', doctorName: 'Sandeep Singh', specialty: 'Cardiology' },
    { date: '1 Dec 2023', visitType: 'Inpatient', doctorName: 'Sandeep Singh', specialty: 'Cardiology' },
    { date: '1 Dec 2023', visitType: 'Inpatient', doctorName: 'Sandeep Singh', specialty: 'Cardiology' },
    { date: '1 Dec 2023', visitType: 'Inpatient', doctorName: 'Sandeep Singh', specialty: 'Cardiology' },
    { date: '1 Dec 2023', visitType: 'Inpatient', doctorName: 'Sandeep Singh', specialty: 'Cardiology' },
    { date: '1 Dec 2023', visitType: 'Inpatient', doctorName: 'Sandeep Singh', specialty: 'Cardiology' },
  ];

  const itemsPerPage = 5;
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = Math.ceil(prescriptions.length / itemsPerPage);

  const currentData = prescriptions.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const goToPage = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  return (
    <>
      <Navbar />
      <div className="max-w-6xl px-4 mx-auto">
        {/* Breadcrumb */}
        <div className="flex items-center my-3 text-xs text-gray-500">
          <span className="cursor-pointer hover:underline">Home</span>
          <span className="mx-1">/</span>
          <span className="cursor-pointer hover:underline">Patient Portal</span>
          <span className="mx-1">/</span>
          <span className="cursor-pointer hover:underline">My Wellness Space</span>
          <span className="mx-1">/</span>
          <span className="text-gray-700">Prescriptions</span>
        </div>

        {/* Header */}
        <div className="flex items-center mb-4">
          <button className="mr-2 text-gray-700">
            <svg width="20" height="20" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path d="M19 12H5M5 12L12 19M5 12L12 5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>
          <h1 className="text-lg font-medium text-gray-800">Prescriptions</h1>
        </div>

        {/* Table */}
        <div className="overflow-x-auto border border-gray-200 rounded-md shadow-sm">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-100">
              <tr>
                <th className="px-6 py-3 text-xs text-left text-gray-700 uppercase">Date</th>
                <th className="px-6 py-3 text-xs text-left text-gray-700 uppercase">Visit Type</th>
                <th className="px-6 py-3 text-xs text-left text-gray-700 uppercase">Doctor Name</th>
                <th className="px-6 py-3 text-xs text-left text-gray-700 uppercase">Specialty</th>
                <th className="px-6 py-3 text-xs text-center text-gray-700 uppercase" colSpan="2">Actions</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {currentData.map((prescription, index) => (
                <tr key={index} className="hover:bg-gray-50">
                  <td className="px-6 py-4 text-sm text-gray-900 whitespace-nowrap">{prescription.date}</td>
                  <td className="px-6 py-4 text-sm text-gray-900 whitespace-nowrap">{prescription.visitType}</td>
                  <td className="px-6 py-4 text-sm text-gray-900 whitespace-nowrap">{prescription.doctorName}</td>
                  <td className="px-6 py-4 text-sm text-gray-900 whitespace-nowrap">{prescription.specialty}</td>
                  <td className="px-3 py-4 text-sm text-center whitespace-nowrap">
  <button className="inline-flex items-center gap-1 px-3 py-1.5 text-xs font-medium text-teal-600 bg-teal-50 hover:bg-teal-100 rounded-md">
    <Eye className="w-4 h-4" />
    View
  </button>
</td>
<td className="px-3 py-4 text-sm text-center whitespace-nowrap">
  <button className="inline-flex items-center gap-1 px-3 py-1.5 text-xs font-medium text-teal-600 bg-teal-50 hover:bg-teal-100 rounded-md">
    <Printer className="w-4 h-4" />
    Print
  </button>
</td>

                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Pagination Controls */}
        <div className="flex justify-center gap-2 mt-4">
          <button
            onClick={() => goToPage(1)}
            disabled={currentPage === 1}
            className="px-3 py-1 text-sm border rounded disabled:opacity-50"
          >
            <Rewind />
          </button>
          <button
            onClick={() => goToPage(currentPage - 1)}
            disabled={currentPage === 1}
            className="px-3 py-1 text-sm border rounded disabled:opacity-50"
          >
            <ChevronLeft />
          </button>
          {Array.from({ length: totalPages }, (_, i) => (
            <button
              key={i}
              onClick={() => goToPage(i + 1)}
              className={`px-3 py-1 text-sm border rounded-full ${currentPage === i + 1 ? 'bg-teal-500 text-white' : ''}`}
            >
              {i + 1}
            </button>
          ))}
          <button
            onClick={() => goToPage(currentPage + 1)}
            disabled={currentPage === totalPages}
            className="px-3 py-1 text-sm border rounded disabled:opacity-50"
          >
            <ChevronRight />
          </button>
          <button
            onClick={() => goToPage(totalPages)}
            disabled={currentPage === totalPages}
            className="px-3 py-1 text-sm border rounded disabled:opacity-50"
          >
            <FastForward />
          </button>
        </div>
      </div>
      <Footer />
    </>
  );
}
